<template>
  <v-card>
    <v-card-title>
        Adicionar uma nova versão
    </v-card-title>
    <v-container flex>
      <v-form lazy-validation v-model="valid" ref="formVersao">
        <v-layout row wrap fill-height justify-space-between>
            <v-flex xs5>
                <v-text-field
                  label="Versão"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="dadosVersao.versao"
                  required
                >
                </v-text-field>
            </v-flex>
            <v-flex xs5>
                <v-text-field
                  label="Data da versão"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  type="date"
                  v-model="dadosVersao.data_versao"
                  required
                >
                </v-text-field>
            </v-flex>
        </v-layout>
            <v-layout row wrap align-center>
                Qual aplicação:
                <v-spacer></v-spacer>
                <v-radio-group
                  row
                  v-model="aplicacaoGroup"
                  :rules="[(v) => !!v || 'Selecione uma aplicação']"
                  required
                >
                  <v-radio
                    color="primary"
                    label="App Clientes"
                    value="cliente"
                  ></v-radio>
                  <v-radio
                    color="primary"
                    label="App Postos"
                    value="posto"
                  ></v-radio>
                </v-radio-group>
            </v-layout>
        <v-layout>
            <v-flex xs12>
                <v-textarea
                    v-model="dadosVersao.descricao"
                    counter="500"
                    label="Descrição"
                    required
                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                >
                </v-textarea>
            </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
        <v-btn flat color="info" @click="fechar()">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat color="info" @click="inserirVersao()">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { versionamentoDao } from '@/api'

export default {
  data () {
    return {
      valid: false,
      aplicacaoGroup: null,
      dadosVersao: {
        descricao: null,
        versao: null,
        data_versao: null,
        app_cliente: false,
        app_posto: false
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    }
  },
  watch: {
    aplicacaoGroup (val) {
      if (val === 'cliente') {
        this.dadosVersao.app_cliente = true
        this.dadosVersao.app_posto = false
      } else if (val === 'posto') {
        this.dadosVersao.app_posto = true
        this.dadosVersao.app_cliente = false
      }
    }
  },
  methods: {
    fechar () {
      this.$refs.formVersao.reset()
      this.$emit('fechar')
    },
    inserirVersao () {
      if (this.$refs.formVersao.validate()) {
        versionamentoDao.insert(this.dadosVersao, this.headers)
          .then(response => {
            if (response.ok) {
              this.$emit('info', 'Nova versão adicionada com sucesso')
              this.fechar()
            } else {
              this.$emit('error', 'Não foi possível adicionar a nova versão')
              this.fechar()
            }
          })
      }
    }
  }
}
</script>
